export function scrollHoriz(el) {
    // console.log(el);

    el.style.touchAction = 'none'
    el.style.userSelect = 'none'

    let startX,
        scrollLeft

    el.addEventListener('pointerdown', (e) => {
        scrollLeft = el.scrollLeft
        startX = e.pageX - el.offsetLeft;


        el.setPointerCapture(e.pointerId)

        setTimeout(()=> el.classList.add('non-active-anchor'),100)

        // el.onClick=(ee)=>ee.preventDefault()

        el.addEventListener('pointermove', move, false)

        el.addEventListener('pointerup', e => {
            // el.onClick=()=>{}

            el.classList.remove('non-active-anchor')
            setTimeout(()=> el.classList.remove('non-active-anchor'),100)

            // console.log('removing event listernrer');
            el.removeEventListener('pointermove', move)

        }, { once: true })

    }, false)

    function move(e) {
        
        const x = e.pageX - el.offsetLeft;
        const walk = (x - startX) * 2;
        el.scrollLeft = scrollLeft - walk;
        
        // console.log('scrollLeft , e.clientX , e.target.getBoundingClientRect().left', el.scrollLeft, e.clientX, el.getBoundingClientRect().left);
        // el.scrollLeft +=  el.getBoundingClientRect().right - e.clientX

    }

}

